import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  useEffect,
} from "react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

const DirectionContext = createContext();

const createEmotionCache = (dir) =>
  createCache({
    key: dir === "rtl" ? "muirtl" : "muiltr",
    stylisPlugins: dir === "rtl" ? [prefixer, rtlPlugin] : [],
  });

const getInitialDirection = () => {
  const storedLang = localStorage.getItem("appLanguage");
  return storedLang && storedLang.trim() === "he" ? "rtl" : "ltr";
};

export const DirectionProvider = ({ children }) => {
  const [direction, setDirection] = useState(getInitialDirection());

  const toggleDirection = () => {
    const newDir = direction === "ltr" ? "rtl" : "ltr";
    setDirection(newDir);
  };

  const emotionCache = useMemo(
    () => createEmotionCache(direction),
    [direction]
  );

  useEffect(() => {
    document.body.dir = direction;
  }, [direction]);

  return (
    <DirectionContext.Provider
      value={{ direction, setDirection, toggleDirection, emotionCache }}
    >
      {children}
    </DirectionContext.Provider>
  );
};

export const useDirection = () => useContext(DirectionContext);
